
const OperationConfig = {
    'updateWipeChange': '抹零',
    'changeMember': '修改会员',
    'updateSingleSale': '单品打折',
    'updateTotalSale':'整单打折',
    'updateTotalPresent':'整单赠送',
    'updateSingleAmount': '单品金额',
    'deleteBodyItem': '删除明细行',
    'updateQuantity': '修改数量',
    'updateTaxPrice': '修改含税单价',
    'updateTaxAmount': '修改含税金额',
    'updateVoucherDate': '修改单据日期',
    'updateFreeItem':'修改自由项',
    'updateBatch':'修改批号',
    'updateSingleMemo':'修改备注',
    'updateQuantity2':'修改数量二',
    'updateGuide':'改导购',
    'updateSingleGuide':'改单行导购', 
    'updateSinglePresent':'设置行赠品',
    'printRetail':'打印零售单',
    'newRetailOrder':'重新开单',
    'clearVoucherData':'清空单据信息',
    'hangUpOrder':'挂单',
    'hangOffOrder':'解挂'
}

export default OperationConfig;
